import { useState, useEffect } from "react";
import { apiClient } from "../apiClient";

export function useExercise(exerciseId) {
  const [exercise, setExercise] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExercise = async () => {
      try {
        setLoading(true);
        const data = await apiClient.getExercise(exerciseId);
        setExercise(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching exercise:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (exerciseId) {
      fetchExercise();
    }
  }, [exerciseId]);

  return { exercise, loading, error };
}
